import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("oep_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const original = error.config;
    const noRefresh = ["/auth/login", "/auth/refresh", "/auth/logout", "/auth/forgot-password", "/auth/reset-password", "/auth/google/session"];
    const skipRefresh = noRefresh.some((path) => original?.url?.includes(path));
    const hasAuthMarker = document.cookie.includes("auth_present=1");
    if (error.response?.status === 401 && original && !original._retry && !skipRefresh && hasAuthMarker) {
      original._retry = true;
      try {
        await api.post("/auth/refresh");
        return api(original);
      } catch (refreshError) {
        localStorage.removeItem("oep_token");
      }
    }
    return Promise.reject(error);
  }
);


export const eur = (n) =>
  new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR", maximumFractionDigits: 0 }).format(n);

export const priceLabel = (p) => (p.price > 0 ? eur(p.price) : "Su richiesta");

export const whatsappLink = (p) =>
  `https://wa.me/393511997843?text=${encodeURIComponent(
    `Salve, sono interessato a "${p.name}" (rif. ${p.reference}) visto su orologi-preziosi.it`
  )}`;

export function formatApiError(detail, fallback = "Si è verificato un errore. Riprova.") {
  if (detail == null) return fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
